import script from "./AdminPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminPage.vue?vue&type=style&index=0&id=19e9a6f5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\Projects\\Commercial\\GEMA\\Ga-East-Municipal-Assembly\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e9a6f5"]])

export default __exports__